export default __webpack_public_path__ + "static/floor3-room-1089d20d9050d5ada0709564f7f1b045.jpg";